export const getRole = async () => JSON.parse(localStorage.getItem('user'));